(function () {
    'use strict';

    angular.module('caffeprint')
        .directive('cpSaveFile', cpSaveFile);

    cpSaveFile.$inject = ['saveFileSrvc'];

    function cpSaveFile(saveFileSrvc) {
        return {
            restricted: 'A',
            scope: {
                saveFileName: '='
            },
            link: function (scope, element, attrs) {

                element.on('click', function (e) {
                    e.preventDefault();

                    saveFileSrvc.saveFile(attrs['cpSaveFile'], scope.saveFileName);
                })
            }
        }
    }
})();
